/* eslint-disable import/prefer-default-export */
export const DATE_INPUT_TEXT_FORMAT = "YYYY-MM-DD";
export const SALESFORCE_DATE_AND_TIME = "YYYY-MM-DD HH:mm:ss";
export const DATE_SLASH_FORMAT = "DD/MM/YYYY";
export const DATE_DISPLAY_FORMAT = {
  th: "D MMM BBBB",
  en: "D MMM YYYY",
};
